/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Import,
  ImportBulkInput,
  ImportCleanupResult,
  Imports,
  ImportsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * Get a List of Imports
 * @summary Imports list
 */
export const imports = (
    params?: MaybeRefOrGetter<ImportsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Imports>(
      {url: `/imports`, method: 'GET',
        params, signal
    },
      );
    }




export const getImportsQueryKey = (params?: MaybeRefOrGetter<ImportsParams>,) => {
    return [
    'imports', ...(params ? [params] : [])
    ] as const;
    }


export const getImportsQueryOptions = <TData = Awaited<ReturnType<typeof imports>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ImportsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof imports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImportsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof imports>>> = ({ signal }) => imports(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof imports>>, TError, TData>
}

export type ImportsQueryResult = NonNullable<Awaited<ReturnType<typeof imports>>>
export type ImportsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Imports list
 */

export function useImports<TData = Awaited<ReturnType<typeof imports>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ImportsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof imports>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Mark the running Imports among a selection as failed
 * @summary Clean up a selection of Imports
 */
export const cleanupBulkImports = (
    importBulkInput: MaybeRefOrGetter<ImportBulkInput>,
 signal?: AbortSignal
) => {
      importBulkInput = toValue(importBulkInput);

      return axiosClient<ImportCleanupResult>(
      {url: `/imports/cleanup-bulk`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: importBulkInput, signal
    },
      );
    }




export const getCleanupBulkImportsMutationKey = () => ['cleanupBulkImports'] as const;

export const getCleanupBulkImportsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupBulkImports>>, TError,CleanupBulkImportsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cleanupBulkImports>>, TError,CleanupBulkImportsMutationVariables, TContext> => {

const mutationKey = getCleanupBulkImportsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cleanupBulkImports>>, CleanupBulkImportsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  cleanupBulkImports(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CleanupBulkImportsMutationResult = NonNullable<Awaited<ReturnType<typeof cleanupBulkImports>>>
    export type CleanupBulkImportsMutationBody = ImportBulkInput
    export type CleanupBulkImportsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CleanupBulkImportsMutationVariables = {data: ImportBulkInput}

    /**
 * @summary Clean up a selection of Imports
 */
export const useCleanupBulkImports = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupBulkImports>>, TError,CleanupBulkImportsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cleanupBulkImports>>,
        TError,
        CleanupBulkImportsMutationVariables,
        TContext
      > => {
      return useMutation(getCleanupBulkImportsMutationOptions(options), queryClient);
    }
    /**
 * @summary Import Detail
 */
export const _import = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Import>(
      {url: `/imports/${id}`, method: 'GET', signal
    },
      );
    }




export const getImportQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'imports',id
    ] as const;
    }


export const getImportQueryOptions = <TData = Awaited<ReturnType<typeof _import>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof _import>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getImportQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof _import>>> = ({ signal }) => _import(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof _import>>, TError, TData>
}

export type _ImportQueryResult = NonNullable<Awaited<ReturnType<typeof _import>>>
export type _ImportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Import Detail
 */

export function useImport<TData = Awaited<ReturnType<typeof _import>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof _import>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getImportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Mark a running Import as failed, for a job that never reported back
 * @summary Clean up a stuck Import
 */
export const cleanupImport = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Import>(
      {url: `/imports/${id}/cleanup`, method: 'PUT', signal
    },
      );
    }




export const getCleanupImportMutationKey = () => ['cleanupImport'] as const;

export const getCleanupImportMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupImport>>, TError,CleanupImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cleanupImport>>, TError,CleanupImportMutationVariables, TContext> => {

const mutationKey = getCleanupImportMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cleanupImport>>, CleanupImportMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  cleanupImport(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CleanupImportMutationResult = NonNullable<Awaited<ReturnType<typeof cleanupImport>>>

    export type CleanupImportMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CleanupImportMutationVariables = {id: string}

    /**
 * @summary Clean up a stuck Import
 */
export const useCleanupImport = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cleanupImport>>, TError,CleanupImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cleanupImport>>,
        TError,
        CleanupImportMutationVariables,
        TContext
      > => {
      return useMutation(getCleanupImportMutationOptions(options), queryClient);
    }
